import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "新闻", to: "/news" },
  { label: "专题", to: "/special" },
  { label: "关于", to: "/about" },
];

export default function Header() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const keyword = query.trim();
    setMenuOpen(false);
    if (keyword) {
      navigate(`/category/all?q=${encodeURIComponent(keyword)}`);
    } else {
      navigate("/category/all");
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center h-16 md:h-[68px] gap-4 md:gap-8">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-movie-2-fill text-lg"></i>
            </span>
            <span className="text-base md:text-lg font-bold tracking-tight whitespace-nowrap">
              国语对白做受<span className="text-accent-400">69</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-accent-400 font-medium"
                      : "text-background-200 hover:text-background-50 hover:bg-primary-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3 ml-auto">
            <form onSubmit={handleSearch} className="hidden sm:flex items-center">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-background-400 text-sm"></i>
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜索影视作品 / 资讯"
                  className="w-44 lg:w-64 h-9 pl-9 pr-3 rounded-md bg-primary-900 border border-primary-700 text-sm text-background-50 placeholder:text-background-500 focus:outline-none focus:border-accent-500 transition-colors"
                />
              </div>
              <button
                type="submit"
                className="ml-2 h-9 px-4 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 hover:bg-primary-800 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-primary-800 bg-primary-950 px-4 py-4 space-y-3">
          <form onSubmit={handleSearch} className="flex items-center gap-2">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-background-400 text-sm"></i>
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索影视作品 / 资讯"
                className="w-full h-10 pl-9 pr-3 rounded-md bg-primary-900 border border-primary-700 text-sm text-background-50 placeholder:text-background-500 focus:outline-none focus:border-accent-500"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-md bg-accent-500 text-primary-950 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="grid grid-cols-3 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm text-center transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-800 text-accent-400 font-medium"
                      : "bg-primary-900 text-background-200 hover:text-background-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}